import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core'
import { CommonModule } from '@angular/common'
import { MyFavouritesListComponent } from './my-favourites-list/my-favourites-list.component'
import { AddToCartModule } from '../cart/add-to-cart/add-to-cart.module'
import {
  MediaModule,
  SpinnerModule,
  ListNavigationModule,
  DIALOG_TYPE,
} from '@spartacus/storefront'
import { ReactiveFormsModule, FormsModule } from '@angular/forms'
import {
  I18nModule,
  UrlModule,
  ConfigModule,
  provideConfig,
} from '@spartacus/core'
import { RouterModule } from '@angular/router'
import { MyFavouritesService } from './my-favourites.service'
import { EmptyListComponent } from './empty-list/empty-list.component'
import { MyFavouritesDialogComponent } from './my-favourites-dialog/my-favourites-dialog.component'
import { SingleQuoteDialogComponent } from './my-favourites-dialog/single-quote-dialog/single-quote-dialog.component'
import { environment } from '../../../environments/environment'
import { QuantityCounterModule } from '../../shared/components/quantity-counter/quantity-counter.module'
import { VS_LAUNCH_CALLER } from '../config/dialog.config'

@NgModule({
  declarations: [
    MyFavouritesListComponent,
    EmptyListComponent,
    MyFavouritesDialogComponent,
    SingleQuoteDialogComponent,
  ],
  imports: [
    CommonModule,
    AddToCartModule,
    QuantityCounterModule,
    MediaModule,
    SpinnerModule,
    I18nModule,
    ReactiveFormsModule,
    ListNavigationModule,
    UrlModule,
    RouterModule,
    FormsModule,
    I18nModule,
    ConfigModule.withConfig({
      i18n: {
        backend: {
          loadPath:
            environment.deployPath + '/assets/i18n-assets/{{lng}}/{{ns}}.json',
        },
        chunks: {
          common: ['myFavourites'],
        },
      },
    }),
  ],
  exports: [MyFavouritesListComponent],
  providers: [
    MyFavouritesService,
    provideConfig({
      launch: {
        [VS_LAUNCH_CALLER.MY_FAVOURITES]: {
          inlineRoot: true,
          component: MyFavouritesDialogComponent,
          dialogType: DIALOG_TYPE.DIALOG,
        },
        [VS_LAUNCH_CALLER.SINGLE_QUOTE]: {
          inlineRoot: true,
          component: SingleQuoteDialogComponent,
          dialogType: DIALOG_TYPE.DIALOG,
        },
      },
    }),
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class MyFavouritesModule {}
